import React from 'react';
import PageInstitutional from './components/PageInstitutional';
import { subMenuWording } from 'common/constants/subMenuWording';

const Exploitation = ({ match }) => (
  <PageInstitutional match={match} routes={subMenuWording.EXPLOITATION} />
);

export default Exploitation;
